import React from 'react';
import i18n from 'i18next';

import { Insignias } from 'uikit/insignias';
import { Typo } from 'uikit/content';

import styles from '../styles/profileSkillsListItem.module.scss';

const ProfileSkillsListItem = ({
  skill,
}) => {
  const insignias = [
    {
      icon: 'reputation',
      text: (skill && skill.reputation_points) ? skill.reputation_points.toString() : '0',
      tooltip: i18n.t('reputation'),
    },
  ];

  return (
    <a className={styles.link} href={`/student/catalog/list?inline_search=true&taxonomy_tag_ids[]=${skill.id}`}>
      <span className={styles.dot} style={{ backgroundColor: skill.hex_color }} />
      <Typo
        element="span"
        variant="s02"
        weight="medium"
      >
        {skill.name}
      </Typo>
      <Insignias
        className={styles.insignias}
        insigniasIconSize={18}
        insignias={insignias}
      />
    </a>
  );
};

export default React.memo(ProfileSkillsListItem);
